import React from 'react';

import { useClassnames } from '@lumapps/classnames';
import { Theme, useTheme } from '@lumapps/lumx/react';
import type { ElementRender } from '@lumapps/wrex/types';

import { COLUMN } from '../../../constants';
import type { ColumnElement } from '../../../types';

import './index.scss';

export const CLASSNAME = 'wrex-content-column';

export const Column: ElementRender<ColumnElement, HTMLDivElement> = (props) => {
    // eslint-disable-next-line unused-imports/no-unused-vars
    const { children, className, elementRef, element, ...forwardedProps } = props;
    const { block } = useClassnames(CLASSNAME);
    const theme = useTheme() || Theme.light;

    return (
        <div className={block({ [`theme-${theme}`]: true }, [className])} ref={elementRef} {...forwardedProps}>
            {children}
        </div>
    );
};

Column.displayName = COLUMN;
